import { bytesToGB } from '@/utils'
import { enumsData } from '@/mixins/enums'

export default {
    mixins: [enumsData],
    methods: {
        bytesToGB(bytes) {
            return bytesToGB(bytes)
        },
        usageColor(usage) {
            return usage < 60 ? 'success' : usage < 90 ? 'amber' : 'error'
        },
        fileTypeLabel(type) {
            switch (type) {
                case this.folderTypesLabels.WORKSPACE_FILES:
                    return 'Workspace'
                case this.folderTypesLabels.PERSONAL_FILES:
                    return 'Personal'
                case this.folderTypesLabels.LIBRARY_FILES:
                    return 'Application'
                default:
                    return 'Instance'
            }
        }
    }
}
